import React, { useState } from "react";
import { useGetAllSubscriptionsQuery } from "../../redux/Slices/subscriptionApi";
import RTLDataGrid from "components/styled-component/RTLDataGrid";
import { Backdrop, Box, CircularProgress } from "@mui/material";
import MDTypography from "components/MDTypography";
import AddIcon from "@mui/icons-material/Add";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Card from "@mui/material/Card";
import SubscriptionForm from "./SubscriptionForm";
import SubscriptionUpdateForm from "./SubscriptionUpdateForm";
import ShowSupscriptionDetails from "./ShowSupscriptionDetails";
const columns = [
  {
    field: "storeName",
    headerName: "اسم المتجر",
    width: 150,
    valueGetter: (value, row) => {
      // console.log('Store valueGetter - value:', value, 'row:', row); // Debug log
      return row?.store?.name_ar || "غير متوفر";
    },
  },
  {
    field: "planName",
    headerName: "الخطة",
    width: 120,
    valueGetter: (value, row) => {
      // console.log('Plan valueGetter - value:', value, 'row:', row); // Debug log
      return row?.plan?.name || "غير متوفر";
    },
  },
  {
    field: "price",
    headerName: "السعر",
    width: 100,
    type: "number",
    valueGetter: (value, row) => {
      // console.log('Price valueGetter - value:', value, 'row:', row.plan.price); // Debug log
      return row.plan.price ?? 0;
    },
  },
  {
    field: "billingCycle",
    headerName: "نوع الاشتراك",
    width: 120,
    valueGetter: (value, row) => {
      // console.log('Billing valueGetter - value:', value, 'row:', row); // Debug log
      const billingCycle = row?.plan?.billing_cycle;
      if (!billingCycle) return "غير متوفر";
      return billingCycle === "monthly" ? "شهري" : billingCycle === "yearly" ? "سنوي" : "غير متوفر";
    },
  },
  {
    field: "startDate",
    headerName: "بداية الاشتراك",
    width: 150,
    valueGetter: (value, row) => {
      // console.log('Start date valueGetter - value:', value, 'row:', row); // Debug log
      const startDate = row?.start_date;
      // console.log("🚀 ~ startDate:", startDate)

      return startDate ? startDate.split("T")[0] : "غير متوفر";
    },
  },
  {
    field: "endDate",
    headerName: "نهاية الاشتراكات",
    width: 150,
    valueGetter: (value, row) => {
      // console.log('End date valueGetter - value:', value, 'row:', row); // Debug log
      const endDate = row?.end_date;
      return endDate ? endDate.split("T")[0] : "غير متوفر";
    },
  },
  {
    field: "autoRenew",
    headerName: "تجديد الاشتراك",
    width: 120,
    valueGetter: (value, row) => {
      // console.log('Auto renew valueGetter - value:', value, 'row:', row); // Debug log
      const autoRenew = row?.auto_renew;
      if (autoRenew === undefined || autoRenew === null) return "غير متوفر";
      return autoRenew ? "تلقائي" : "غير تلقائي";
    },
  },
];

const SubscriptionsScreen = () => {
  const { data: subscriptions, isLoading, error } = useGetAllSubscriptionsQuery();
  // ! Map object to get subscription by id and increase performance
  const subscriptionsData = new Map(
    subscriptions?.data?.map((subscription) => [subscription.id, subscription])
  );
  console.log("🚀 ~ SubscriptionsScreen ~ subscriptionsSet:", subscriptionsData);
  console.log("🚀 ~ SubscriptionsScreen ~ subscriptions 1:", subscriptionsData.get(2));

  const [ShowSupscriptionDetailsOpen, setShowSupscriptionDetailsOpen] = useState(false);
  const [updateMode, setUpdateMode] = useState(false);
  console.log("🚀 ~ SubscriptionsScreen ~ subscriptions:", subscriptions);
  const [specificSupscription, setSpecificSupscription] = useState(null);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [storeId, setStoreId] = useState(null);
  const rows =
    subscriptions?.data?.map((item, index) => ({
      ...item,
      id: item.id ?? `fallback-id-${index}`,
    })) ?? [];

  const handleShow = (subscription) => {
    console.log("Show subscription", subscription);
    setSubscriptionId(subscription.id);

    setShowSupscriptionDetailsOpen(true);
  };

  const handleUpdate = (subscription) => {
    setUpdateMode(true);
    setSubscriptionId(subscription.id);
    setSpecificSupscription(subscription);
    setStoreId(subscription.store.id);
    console.log("Update subscription", subscription);
    // alert(`تحديث: ${subscription.store?.name_ar ?? 'غير متوفر'} (ID: ${subscription.id ?? 'غير متوفر'})`);
  };

  const handleDelete = (subscription) => {
    console.log("Delete subscription", subscription);
    alert(
      `حذف: ${subscription.store?.name_ar ?? "غير متوفر"} (ID: ${subscription.id ?? "غير متوفر"})`
    );
  };

  const handleActive = (subscription) => {
    console.log("Active subscription", subscription);
    alert(
      `تفعيل: ${subscription.store?.name_ar ?? "غير متوفر"} (ID: ${subscription.id ?? "غير متوفر"})`
    );
  };

  if (isLoading) {
    return (
      <>
        <Backdrop open={isLoading} sx={{ zIndex: 2000, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </>
    );
  }

  if (error) {
    return (
      <div style={{ textAlign: "right", fontFamily: '"Noto Sans Arabic", sans-serif' }}>
        فشل في جلب البيانات críticos {error?.data?.message ?? "حدث خطأ"}
      </div>
    );
  }

  return (
    <MDBox pt={6} pb={3}>
      <SubscriptionUpdateForm
        subscription={specificSupscription}
        subscriptionId={subscriptionId}
        open={updateMode}
        onClose={() => setUpdateMode(false)}
        storeId={storeId}
      />
      {ShowSupscriptionDetailsOpen && (
        <ShowSupscriptionDetails
          subscription={subscriptionsData.get(subscriptionId)}
          open={ShowSupscriptionDetailsOpen}
          onClose={() => setShowSupscriptionDetailsOpen(false)}
        />
      )}
      <Card>
        <MDBox
          mx={2}
          mt={-3}
          mb={3}
          py={3}
          px={2}
          borderRadius="lg"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            background: "linear-gradient(90deg, #ca9937, #e0b15a)",
            boxShadow: 3,
          }}
        >
          <MDTypography variant="h6" color="white">
            قائمة الاشتركات
          </MDTypography>
        </MDBox>
        <Box>
          <RTLDataGrid
            rows={rows}
            columns={columns}
            onShow={handleShow}
            onUpdate={handleUpdate}
            onDelete={handleDelete}
            onActive={handleActive}
          />
        </Box>
      </Card>
    </MDBox>
  );
};

export default SubscriptionsScreen;
